<template>
    <div class="mt-3 mb-3 text-center header-area">
        <Image v-if="subscriptionDetails.logo" class="img-thumbnail"
               :src="subscriptionDetails.logo" width="100" />
        <h3 class="text-center">{{ subscriptionDetails.header }}</h3>
    </div>
    <div class="mb-3 text-center" v-html="subscriptionDetails.description"></div>
</template>
<script>

export default {
    props: {
        modelValue: {}
    },
    components: {
    },
    data () {
        return {
            subscriptionDetails: {
            },
        }
    },
    mounted () {
        this.subscriptionDetails = this.modelValue
    },
}
</script>

